import { useApiPost } from '../../api/Api.hooks';
import { StudyParticipant } from '../../models/StudyParticipant';

export function useRestartStudyParticipant(studyParticipantId: number) {
  const path = `study-participants/${studyParticipantId}/restart`;
  const { data, isLoading, error, post } = useApiPost<StudyParticipant>(path);
  return {
    restartedStudyParticipant: data,
    restartingStudyParticipant: isLoading,
    restartingStudyParticipantError: error,
    restartStudyParticipant: post
  };
}
